module.exports = __webpack_public_path__ + "static/img/2_1_2_2.9e1b7da4.jpg";